import { Button, Typography } from '@material-ui/core';
// import { withStyles } from '@material-ui/styles';
import { withStyles } from '@material-ui/core/styles';

import React from 'react';

import { fonts, text14 } from '../../utilities/styles';

const StyledButton = withStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    width: theme.spacing(37),
    borderRadius: theme.spacing(1),
    boxShadow: 'none',
    // border: `${theme.spacing(0.3)}px solid ${theme.palette.secondary.light}`,
    border:'none',
    color: (props) =>
      `${
        props.secondary
          ? theme.palette.primary.main
          : theme.palette.common.white
      }`,
    '&.MuiButton-root': {
      background: (props) => 
        props.disabled
          ? `${theme.palette.secondary.main}`
          : `${"#6b7afd"} !important`,
    },
    ['@media (max-width:780px)']: {
      width: '100% !important',
    },
  },
}))(Button);

const CustomButton = ({
  disabled,
  onClick,
  children,
  style,
  color,
  textStyle,
  variant,
  secondary,
}) => {
  return (
    <>
      <StyledButton
        secondary={secondary}
        disabled={disabled}
        onClick={onClick}
        variant={variant ? variant : 'contained'}
        disableElevation
        style={{ textTransform: 'none', ...style }}
      >
        <Typography style={{ ...fonts.lexend.style, ...text14, ...textStyle }}>
          {children}
        </Typography>
      </StyledButton>
    </>
  );
};

export default CustomButton;
